import Vuex from "vuex"

const state = {
    visitorSession: null
};

const store = new Vuex.Store({
    state,
    getters:{
        visitorSessionStore: (state) => {
            //console.log(state.companyUserStore)
            return state.visitorSession;
        }
    },
    actions:{
        visitorSessionStore(context, visitorSession){
            context.commit('visitorSession', visitorSession)
        }
    },
    mutations:{
        visitorSessionStore(state, visitorSession) {
            state.visitorSession = visitorSession;
        }
    }
})

export default store
